<template>
  <span>
    <!-- grid search -->
    <v-row>
      <v-col :cols="disabled?12:6">
        <v-text-field
          v-model="keyword"
          append-icon="mdi-magnify"
          label="Cari"
          hide-details
          single-line
          clearable
        ></v-text-field>
      </v-col>
      <!-- form rincian transaksi -->
      <v-col cols="6" class="text-right" v-if="!disabled">
        <v-btn class="ml-2 mt-2" color="primary" outlined @click="addItem">
          <span class="hidden-xs-only">Tambah</span>
          <v-icon :right="!$vuetify.breakpoint.xsOnly">mdi-plus-box</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" persistent max-width="300px">
          <ValidateAll ref="form">
            <v-form>
              <v-card>
                <v-card-title>Rincian Transaksi</v-card-title>
                <v-divider></v-divider>
                <v-card-text class="dialog-form">
                  <Validate name="Jenis transaksi" rules="fully_required" #default="{ errors }">
                    <v-select
                      :error-messages="errors"
                      hide-details="auto"
                      v-model="item.Jenis"
                      :items="list.jenisTransaksi"
                      @input="changeJenisTransaksi"
                      label="Jenis Transaksi"
                    >
                      <template v-slot:selection="{ item }">
                        <v-icon
                          v-text="item.value == 'penerimaan' ? 'mdi-wallet':'mdi-cart'"
                          small
                          left
                        ></v-icon>
                        <span>{{item.text}}</span>
                      </template>
                    </v-select>
                  </Validate>
                  <br />
                  <Validate name="Rekening" rules="fully_required" #default="{ errors }">
                    <v-autocomplete
                      :error-messages="errors"
                      hide-details="auto"
                      v-model="item.Rekening"
                      :items="listRekening"
                      :loading="isRekeningLoading"
                      :search-input.sync="rekening.keyword"
                      :filter="filterRekening"
                      item-text="Nama"
                      item-value="IDRekening"
                      hide-no-data
                      label="Rekening"
                      placeholder="Pencarian rekening"
                      return-object
                    >
                      <template v-slot:selection="data">
                        <div class="text--secondary caption mb-n2 mt-2">{{data.item.Kode}}</div>
                        <v-list-item-title>{{data.item.Nama}}</v-list-item-title>
                      </template>
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-item-content v-text="data.item"></v-list-item-content>
                        </template>
                        <template v-else>
                          <v-list-item-content>
                            <v-list-item-title class="py-0">
                              {{data.item.Nama}}
                              &mdash;
                              <span
                                class="text--secondary"
                              >{{data.item.Kode}}</span>
                            </v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </Validate>
                  <br />
                  <Validate name="Nominal" rules="required|min_value:1" #default="{ errors }">
                    <v-text-field
                      :error-messages="errors"
                      hide-details="auto"
                      v-model="item.Nominal"
                      label="Nominal"
                      placeholder="Nominal"
                      type="number"
                    ></v-text-field>
                  </Validate>
                  <br />
                  <v-textarea
                    v-model="item.Keterangan"
                    no-resize
                    rows="2"
                    name="Keterangan"
                    label="Keterangan"
                    placeholder="Keterangan"
                  ></v-textarea>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn color="secondary" text @click="dialog = false">Batal</v-btn>
                  <v-spacer />
                  <v-btn color="primary" text @click="saveItem">Simpan</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </ValidateAll>
        </v-dialog>
      </v-col>
    </v-row>
    <br />
    <v-row>
      <v-col cols="12" class="px-0 py-0">
        <v-divider />
        <v-data-table
          :headers="headers"
          :items="value"
          :loading="loading"
          :loading-text="app.grid.loading"
          :no-data-text="app.grid.noData"
          :search="keyword"
          multi-sort
          hide-default-footer
          :items-per-page="-1"
        >
          <!-- custom field render -->
          <template v-slot:item.Nominal="{ item }">
            <v-chip :color="item.Jenis == 'belanja'?'primary':'success'" small outlined>
              <v-icon small left>{{item.Jenis == 'belanja'?'mdi-cart':'mdi-wallet'}}</v-icon>
              {{item.Nominal | currency}}
            </v-chip>
          </template>

          <!-- custom updated date & by -->
          <template v-slot:item.LastUpdatedDate="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span dark v-on="on">{{$format.relativeUpdatedDate(item)}}</span>
              </template>
              <span>{{$format.updatedDate(item)}}</span>
            </v-tooltip>
          </template>

          <!-- grid actions -->
          <template v-slot:item.Actions="{ item }" v-if="!disabled">
            <v-btn class="mr-4" icon color="blue" @click="editItem(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" :loading="item.processing">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item @click="deleteItem(item)">
                  <v-list-item-icon>
                    <v-icon color="red">mdi-delete</v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>Hapus</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

          <!-- content edit -->
        </v-data-table>
      </v-col>
    </v-row>
  </span>
</template>

<style lang="scss">
</style>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { clone } from "lodash";

export default {
  name: "rincian-transaksi",
  props: {
    value: Array,
    loading: Boolean,
    disabled: Boolean
  },
  data: () => ({
    proto: {
      uid: "",
      Jenis: "belanja",
      IDRekening: "",
      Rekening: {},
      Nominal: 0,
      Keterangan: "",
      CreatedDate: null,
      LastUpdatedDate: null
    },
    dialog: false,
    rekening: {
      keyword: "",
      awaiting: false
    },
    keyword: "",
    item: {},
    items: [],
    headers: [
      {
        value: "Rekening.Kode",
        text: "Kode",
        width: "10%"
      },
      {
        value: "Rekening.Nama",
        text: "Rekening",
        width: "25%"
      },
      {
        value: "Nominal",
        text: "Nominal",
        width: "20%"
      },
      {
        value: "Keterangan",
        text: "Keterangan",
        width: "20%"
      },
      {
        value: "LastUpdatedDate",
        text: "Terakhir Diubah",
        width: "15%"
      },
      {
        value: "Actions",
        sortable: false,
        width: "15%"
      }
    ]
  }),
  computed: {
    ...mapState({
      app: state => state.app,
      list: state => state.list
    }),
    ...mapGetters("list", [
      "isRekeningLoading",
      "listRekeningBelanja",
      "listRekeningPenerimaan"
    ]),
    listRekening() {
      if (this.item.Jenis == "belanja") return this.listRekeningBelanja;
      return this.listRekeningPenerimaan;
    }
  },
  methods: {
    ...mapActions("list", ["refreshRekening"]),
    addItem() {
      if (this.$refs.form) this.$refs.form.reset();
      this.item = Object.assign({}, this.proto);
      this.item.uid = this.$util.uid();
      this.dialog = true;
    },
    editItem(item) {
      if (this.$refs.form) this.$refs.form.reset();
      this.item = clone(this.preProcessItem(item));
      this.dialog = true;
    },
    async saveItem() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;

      if (this.item.ID) this.item.LastUpdatedDate = new Date();
      else this.item.CreatedDate = new Date();

      this.item = this.preProcessItem(this.item);
      let index = this.value.findIndex(x => x.uid == this.item.uid);

      if (index == -1) this.value.push(this.item);
      else this.$set(this.value, index, this.item);
      this.dialog = false;
    },
    preProcessItem(item) {
      item.Nominal = parseFloat(item.Nominal);
      return item;
    },
    async deleteItem(item) {
      const confirmation = await this.$dialog.confirm({
        text: "Apakah anda yakin menghapus data ?"
      });
      if (confirmation) {
        let index = this.value.findIndex(x => x.uid == item.uid);
        if (index > -1) this.value.splice(index, 1);
      }
    },
    filterRekening(item, queryText) {
      const nama = item.Nama.toLowerCase();
      const kode = item.Kode.toLowerCase();
      const searchText = queryText.toLowerCase();

      return nama.indexOf(searchText) > -1 || kode.indexOf(searchText) > -1;
    },
    changeJenisTransaksi() {
      this.item.Rekening = {};
    }
  },
  watch: {
    "item.Rekening"(v) {
      if (!this.$util.isEmpty(v)) this.item.IDRekening = v.IDRekening;
      else this.item.IDRekening = "";
    }
  }
};
</script>

